/**
 * Nombre qui « compte » jusqu'à sa valeur à l'affichage (KPI du tableau de
 * bord). Part de 0 au montage, puis anime chaque changement de valeur. Coupé si
 * l'appareil demande de réduire les animations (valeur finale directe).
 */
import { useCountUp } from '@/features/skillcards/use-count-up';

/** Valeur affichée à un instant de l'animation, arrondie à `decimals`. */
export function roundCountUp(value: number, decimals = 0): number {
  const f = 10 ** decimals;
  return Math.round(value * f) / f;
}

export function CountUp({
  value,
  decimals = 0,
  format = (n) => String(n),
  duration = 1200,
}: {
  value: number;
  decimals?: number;
  format?: (n: number) => string;
  duration?: number;
}) {
  const shown = useCountUp(value, { duration });
  return (
    <span className="tabular-nums" aria-label={format(roundCountUp(value, decimals))}>
      <span aria-hidden>{format(roundCountUp(shown, decimals))}</span>
    </span>
  );
}
